export default [
  {path:'/reports/payments',name:'payments-reports',meta:{title:'Payments Reports',authRequired:true},component:()=>import('../views/reports/payments-catalogue.vue')},
  {path:'/reports/payments/:reportCode',name:'payments-report-runner',meta:{title:'Payments Report',authRequired:true},component:()=>import('../views/reports/payments-report-runner.vue')}
];
